// Ziyaretci sohbeti kucultunce, "sohbeti ac" modundaki sonraki tetikleyiciler pencereyi yeniden acmasin.
// Yasak, ziyaretci sohbeti kendisi acinca (baloncuk, site butonu, tetikleyici kart butonu) kalkar.
// Sayfa basina bellekte tutulur; sayfa yenilenince sifirlanir.
function createTriggerOpenGuard() {
    let minimizedByVisitor = false;
    return {
        onMinimized() {
            minimizedByVisitor = true;
        },
        onOpened() {
            minimizedByVisitor = false;
        },
        canAutoOpen() {
            return !minimizedByVisitor;
        },
    };
}

module.exports = { createTriggerOpenGuard };



//////////////////
// WEBPACK FOOTER
// ./static/src/triggerOpenGuard.js
// module id = mY8z
// module chunks = 1